export default __webpack_public_path__ + "static/media/estate-homesites-labels-2400.dc288545.jpg";